<template>
    <div class='font-size'>
        <!-- <span v-if="props.column.field == 'action' && (role_ccp == 'admin' || role_ccp == 'Admin')"
            class="d-flex justify-content-center">
            <b-dropdown variant="black" toggle-class="text-decoration-none p-0 " no-caret>
                <template #button-content>
                    <i class="icon-more-alt rounded-circle p-2 action"></i>
                </template>
<b-dropdown-item @click="$emit('closeRow', props)"
    v-if="props.row.user_id != '' && props.row.user_id != null && props.row.user_id != undefined">Close</b-dropdown-item>
<b-dropdown-item @click="$emit('deleteRow', props)" v-else>Delete</b-dropdown-item>
</b-dropdown>
</span> -->
        <span v-if="props.column.field == 'received_date_time'">
            <template v-if="formattedDateTime">
                <div>{{ formattedDateTime[0] }}</div>
                <div>{{ formattedDateTime[1] }}</div>
            </template>
        </span>
        <span v-else-if="props.column.field == 'from'" class="text-nowrap">
            {{ props.formattedRow[props.column.field] }}
        </span>
        <span v-else-if="props.column.field == 'subject'">
            {{ props.formattedRow[props.column.field] }}
        </span>
        <span v-else-if="props.column.field == 'action' && (role_ccp == 'admin' || role_ccp == 'Admin')" class="d-flex">
            <b-dropdown variant="black" toggle-class="text-decoration-none p-0 " no-caret
                :popper-opts="{ positionFixed: true }">
                <template #button-content>
                    <i class="icon-more-alt rounded-circle p-2 action"></i>
                </template>

                <div style="max-height: 400px; overflow-y: auto;">
                    <b-dropdown-item v-for="(item, itemIndex) in setActionMenu(props.row)" :key="itemIndex"
                        @click="sendAction(item, props.row)">
                        <span class="ml-1">{{ item.text }}</span>
                    </b-dropdown-item>
                </div>
            </b-dropdown>
        </span>
        <span v-else class='text-nowrap'>
            {{
                props.formattedRow[props.column.field].length > 20
                    ? props.formattedRow[props.column.field].substring(0, 20) + '...'
                    : props.formattedRow[props.column.field]
            }}
        </span>
    </div>
</template>
<script>
export default ({
    name: 'datatable-row-default',
    props: {
        props: Object,
    },
    data() {
        return {
            role_ccp: "",
            actionMenu: [
                { text: 'Create INC', key: 10 },
                { text: 'Create RITM (Unlock/Reset User Password)', key: 20 },
                { text: 'Create RITM ([DXC] Other Request )', key: 21 },
                { text: 'Create RITM (Application Services - Service Request)', key: 22 },
                { text: 'Create RITM (Service/Enhancement Request)', key: 23 },
                { text: 'Create RITM (Software Uninstallation )', key: 24 },
                { text: 'Create RITM (Non Standard Software Installation)', key: 25 },
                { text: 'Create RITM (Standard Software Installation)', key: 26 },
                { text: 'Create RITM (Active Directory - Existing Account Request)', key: 27 },
                { text: 'Create RITM (Request to Register/Update Mobile Phone Number/Devices for MFA in Microsoft Entra ID)', key: 28 },
                { text: 'Create RITM (Computer - Back-up and Restore)', key: 29 },
                { text: 'Delete', key: 'delete' }
            ],
        }
    },
    mounted() {
        let userinfo = localStorage.getItem('userinfo');
        userinfo = JSON.parse(userinfo);
        if (userinfo.role_ccp != undefined) {
            this.role_ccp = userinfo.role_ccp
        }
    },
    computed: {
        formattedDateTime() {
            if (!this.props.row.received_date_time) return null;
            const formatted = this.$options.filters.moment(this.props.row.received_date_time, 'YYYY-MM-DD, kk:mm:ss');
            return formatted.split(', ');
        }
    },
    methods: {
        setActionMenu(item) {
            if (item.user_name === 'auto-created' || item.user_name === 'created' || (item.user_name !== 'auto-attached' && item.user_name !== '')) {
                return this.actionMenu.filter(action => action.key === 'delete');
            } else {
                return this.actionMenu;
            }
        },
        sendAction(item, row) {
            if (item.text !== 'Delete') {
                this.$emit('editRow', [item, row])
            } else {
                this.$emit('deleteRow', row)
            }
        }
    }
})
</script>

<style scoped>
.font-size {
    font-size: 14px
}

.text-nowrap {
    text-wrap: nowrap;
}
</style>